import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'crmScheduleTime',
  pure: true,
})
export class CrmScheduleTimePipe implements PipeTransform {
  transform(minutes: number, minutesStep: number): string {
    const minutesRemains = minutes % 60;
    const hours = (minutes - minutesRemains) / 60;
    const minutesStr = minutesRemains < 10 ? `0${minutesRemains}` : `${minutesRemains}`;
    const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
    return minutesStep % 60 === 0 ? `${hours}` : `${hoursStr}:${minutesStr}`;
  }
}
